import { render } from "./ComponentBoardItem.vue?vue&type=template&id=64a7bb52&scoped=true"
import script from "./ComponentBoardItem.vue?vue&type=script&lang=js"
export * from "./ComponentBoardItem.vue?vue&type=script&lang=js"

import "./ComponentBoardItem.vue?vue&type=style&index=0&id=64a7bb52&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a7bb52"]])

export default __exports__